import React from 'react';
import { Glyphicon } from 'react-bootstrap';
import '../../../css/flow/editor-getting-started.less';

class FlowEditorGettingStarted extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="flow-editor-getting-started">
                <h2><Glyphicon glyph="share-alt"/> Get started by dragging and dropping an element onto the graph</h2>
            </div>
        );

    }

}

export default FlowEditorGettingStarted;
